export default __webpack_public_path__ + "static/media/portatil_video.21d957cb.png";